import { heicTo } from "heic-to";

const useImageToJpg = (pngFile, optimize = false) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      const canvas = document.createElement("canvas");

      let width = img.width;
      let height = img.height;

      if (optimize) {
        const maxSideSize = 1536;

        if (width >= height && width > maxSideSize) {
          const ratio = maxSideSize / width;
          width = maxSideSize;
          height = height * ratio;
        } else if (height > maxSideSize) {
          const ratio = maxSideSize / height;
          height = maxSideSize;
          width = width * ratio;
        }
      }

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");

      // белый фон вместо прозрачности
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        blob => {
          if (!blob) return reject(new Error("toBlob вернул null"));

          const jpegFile = new File([blob], pngFile.name.replace(/\.(png|bmp)$/i, ".jpg"), { type: "image/jpeg" });

          resolve(jpegFile);
        },
        "image/jpeg",
        optimize ? 0.7 : 1,
      );
    };

    img.onerror = reject;

    const pngUrl = URL.createObjectURL(pngFile);
    img.src = pngUrl;

    // чтобы не было утечки памяти
    img.onloadend = () => URL.revokeObjectURL(pngUrl);
  });
};

const useHeicToPng = async heicFile => {
  return new Promise(async (resolve, reject) => {
    const pngBlob = await heicTo({
      blob: heicFile,
      type: "image/png",
    });
    const pngFIle = new File([pngBlob], heicFile.name.replace(/\.heic$/i, ".png"), { type: "image/png" });
    resolve(pngFIle);
  });
};

export { useImageToJpg, useHeicToPng };
